import HomeNavRecentHeaderActions from './HomeNavRecentHeaderActions'
import HomeNavSectionToggle from './HomeNavSectionToggle'
import HomeNavThreadRows from './HomeNavThreadRows'

const RECENT_VISIBLE_LIMIT = 7

/** Recent section: shows the first 7 chats; the rest live behind search. */
export default function HomeNavRecentSection({ threads, onSearch, onShowMore, ...rowProps }) {
  return (
    <HomeNavSectionToggle
      title="Recent"
      actions={<HomeNavRecentHeaderActions onSearch={onSearch} onFilter={onSearch} />}
    >
      <HomeNavThreadRows
        threads={threads}
        emptyNote="No chats yet"
        maxVisible={RECENT_VISIBLE_LIMIT}
        onShowMore={onShowMore}
        {...rowProps}
      />
    </HomeNavSectionToggle>
  )
}
